import PropTypes from 'prop-types';
import { useState } from 'react';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import axiosInstance from '../../../../utils/axios';
import { fMonthDayYearShort } from '../../../../utils/formatTime';

PermissionHistoryIcon.propTypes = {
  permissionTypeId: PropTypes.number,
  modelId: PropTypes.number,
  modelAttachmentId: PropTypes.number,
};

export default function PermissionHistoryIcon({ permissionTypeId, modelId, modelAttachmentId }) {
  const { enqueueSnackbar } = useSnackbar();

  const [permissionHistory, setPermissionHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  const getPermissionHistory = () => {
    setLoading(true);
    axiosInstance
      .get(`Admin/User/PermissionHistory?permissionTypeId=${permissionTypeId}&modelId=${modelId}&modelAttachmentId=${modelAttachmentId}`)
      .then((res) => {
        if (res.data) setPermissionHistory(res.data)       
        else enqueueSnackbar(`Get permission history failed`, { variant: 'error' });
      })
      .catch(() => enqueueSnackbar(`Get permission history failed`, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return <Tooltip title={permissionHistory ? <>
    {permissionHistory.length ? <Stack spacing={1}>
      {permissionHistory.map((history, index) => <Box key={index}>
        {history.user} <br />
        Added by {history.addedBy ?? "Unknown"} ({new Date(history.dateAdded).getFullYear() > 2000 ? fMonthDayYearShort(history.dateAdded) : "Unknown Date"})
        {history.deletedBy && <br />}
        {history.deletedBy ? `Deleted by ${history.deletedBy} (${fMonthDayYearShort(history.dateDeleted)})` : ""}
      </Box>)}
    </Stack> : "No history found"}
  </> : 'Click to show history'} arrow>
    <span>
      <IconButton color="warning" onClick={getPermissionHistory} disabled={loading} disableRipple sx={{ p: 0, ml: 0.5 }} >
        <HistoryIcon />
      </IconButton>
    </span>
  </Tooltip>;
}
